module.exports = __webpack_public_path__ + "img/register-banner.6c9e8834.png";